module.exports = __webpack_public_path__ + "img/logo-bradesco.c249fb30.png";